import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import Marquee from 'react-fast-marquee';
import { getStoryblokAlt } from '../../helpers/common';

const getStoryblokDimensions = (url) => {
  const [rawWidth, rawHeight] = url?.split('/')[5]?.split('x') || [];
  const width = Number.parseInt(rawWidth, 10);
  const height = Number.parseInt(rawHeight, 10);

  return {
    width: Number.isNaN(width) ? undefined : width,
    height: Number.isNaN(height) ? undefined : height,
  };
};

export default function ImagesSlideshow({ blok }) {
  const styles = clsx('blok-images-slideshow');
  const imageClassName = 'block h-full w-auto max-w-none object-contain';
  const rows = blok?.rows || [];
  const getImageStyle = (width, height) => (
    width && height
      ? { aspectRatio: `${width} / ${height}` }
      : undefined
  );

  const renderImage = (image, rowIndex) => {
    const filename = image.image?.filename;
    const { width, height } = getStoryblokDimensions(filename);

    return (
      <div
        key={`row-${rowIndex}-${image._uid || filename}`}
        className="inline-block flex-shrink-0"
        style={{ paddingRight: '12px' }}
      >
        {filename && (
          <div
            className="h-[352px] max-w-none"
            style={getImageStyle(width, height)}
          >
            <img
              src={filename}
              className={imageClassName}
              alt={getStoryblokAlt(image.image)}
              width={width}
              height={height}
              loading="lazy"
              decoding="async"
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      {...storyblokEditable(blok)}
      className={styles}
      aria-hidden="true"
    >
      <Marquee
        gradient={false}
        play
        autoFill
        className="mb-3"
      >
        {rows[0]?.images?.map((image) => renderImage(image, 0))}
      </Marquee>

      <Marquee
        gradient={false}
        play
        autoFill
      >
        {rows[1]?.images?.map((image) => renderImage(image, 1))}
      </Marquee>
    </div>
  );
}
